export default __webpack_public_path__ + "images/0762e93a5e94622e7ad3cced753ec8a5-american-football.png";